import type { QueryFunctionOptions } from '@apollo/client';

import { useFetchCurrentUserInfoQuery } from './graphql';

type Args = {
  fetchPolicy: QueryFunctionOptions['fetchPolicy'];
};

export function useCurrentUserInfo(props?: Args) {
  const {
    data: currentUserData,
    refetch: refetchCurrentUser,
    loading: isCurrentUserLoading,
  } = useFetchCurrentUserInfoQuery({
    fetchPolicy: props?.fetchPolicy || 'cache-and-network',
  });
  const currentUser = currentUserData?.currentUser;
  const isLogin = !!currentUser?.id;

  return {
    currentUser,
    isLogin,
    isCurrentUserLoading,
    refetchCurrentUser,
  };
}
